<template>
  <div class="step step-one">
    <h2 class="step__title">Getting acquainted</h2>
    <p class="step__description">Please fill in the required data.</p>
    <UIInputText name="refer" label="How would you find new referrals?" placeholder="Type your answer" />
    <UIDropdown
      multiple
      name="countries"
      label="What is referral's country of origin?"
      value-key="id"
      label-key="name"
      :items="countries"
      :loading="isCountriesLoading"
      search-placeholder="Search"
      placeholder="Choose countries"
    />
    <UIDropdown
      name="languages"
      label="What is your preferred language?"
      value-key="id"
      label-key="name"
      :items="languages"
      :loading="isLanguagesLoading"
      placeholder="Choose language"
    />
    <UIInputText
      name="source_of_knowledge"
      label="How did you hear about ThriveState?"
      placeholder="Type your answer"
    />
    <UIButton id="step-two-next" @click="emit('next')">Next</UIButton>
  </div>
</template>

<script setup lang="ts">
const { data: countries, isLoading: isCountriesLoading } = useCountries()
const { data: languages, isLoading: isLanguagesLoading } = useLanguages()

const emit = defineEmits<{
  (e: 'next'): void
}>()
</script>

<style scoped lang="scss">
@import '@/styles/mixins.scss';

@include questionnaireStep();
</style>
